import React, { useEffect, useState, useRef, createElement } from 'react';
import { CheckCircle2 } from 'lucide-react';
function CountdownTimer() {
  const [seconds, setSeconds] = useState(5 * 60 + 59);
  useEffect(() => {
    if (seconds <= 0) return;
    const interval = setInterval(() => setSeconds(s => s - 1), 1000);
    return () => clearInterval(interval);
  }, [seconds]);
  const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');
  return <span className="font-mono font-bold text-white text-xs md:text-base tracking-wider" data-id="element-122">
      {mins}:{secs}
    </span>;
}
declare global {
  interface Window {
    checkoutElements: any;
  }
}
function HotmartSalesFunnel() {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const scriptId = 'hotmart-checkout-elements-dw1';
    const mount = () => {
      if (window.checkoutElements && containerRef.current) {
        containerRef.current.innerHTML = '';
        window.checkoutElements.init('salesFunnel').mount(containerRef.current);
      }
    };
    if (document.getElementById(scriptId)) {
      mount();
      return;
    }
    const existingScript = document.querySelector('script[src="https://checkout.hotmart.com/lib/hotmart-checkout-elements.js"]');
    if (existingScript) {
      mount();
      return;
    }
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
    script.async = true;
    script.onload = mount;
    document.head.appendChild(script);
  }, []);
  return <div ref={containerRef} id="hotmart-sales-funnel-dw1" data-id="element-123"></div>;
}
function Divider() {
  return <div className="w-full h-px bg-brand-gold/20 my-4 md:my-5" data-id="element-124" />;
}
export function DownsellPage1() {
  return <div className="min-h-screen bg-brand-bg flex flex-col" data-id="element-125">
      {/* Top Urgency Banner */}
      <div className="bg-brand-gold text-brand-bg text-center py-1.5 px-3 relative shrink-0" data-id="element-126">
        <p className="font-bold text-[11px] md:text-sm relative z-10 leading-tight" data-id="element-127">
          Espera… Entiendo que el precio te detuvo. ¿Y si te ofrezco Algo Mejor
          ADAPTADO a tu PRESUPUESTO?
        </p>
        <div className="flex items-center justify-center gap-1.5 relative z-10" data-id="element-128">
          <span className="text-brand-bg/70 text-[9px] md:text-xs" data-id="element-129">
            Tiempo restante:
          </span>
          <CountdownTimer data-id="element-130" />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex items-start justify-center px-2.5 md:px-6 py-4 md:py-8" data-id="element-131">
        <div className="w-full max-w-3xl bg-brand-card border border-brand-gold/15 rounded-xl overflow-hidden shadow-2xl shadow-black/30" data-id="element-132">
          <div className="p-4 md:p-8" data-id="element-133">
            {/* Image + Title + Price */}
            <div className="flex flex-row gap-3 md:gap-6 items-start mb-4" data-id="element-134">
              <div className="shrink-0 w-[100px] md:w-[200px]" data-id="element-135">
                <img src="https://cdn.magicpatterns.com/uploads/6zEPisftcL2DrVpJ9hhyuQ/Indice_Activos_Tangibles_Cover.png" alt="El Índice de Activos Tangibles" className="w-full rounded-lg shadow-lg border border-brand-gold/10" data-id="element-136" />
              </div>
              <div className="flex-1 space-y-1.5 md:space-y-3" data-id="element-137">
                <h1 className="text-sm md:text-xl font-bold text-white font-serif leading-tight" data-id="element-138">
                  El Índice de Activos Tangibles
                </h1>
                <div className="flex items-center gap-2 flex-wrap" data-id="element-139">
                  <span className="text-brand-muted line-through text-xs md:text-base" data-id="element-140">
                    $47.00
                  </span>
                  <span className="text-brand-gold font-bold text-lg md:text-2xl" data-id="element-141">
                    $19.00
                  </span>
                  <span className="bg-brand-green/20 text-brand-green text-[9px] md:text-xs font-bold px-1.5 py-0.5 rounded border border-brand-green/30" data-id="element-142">
                    60% OFF
                  </span>
                </div>
              </div>
            </div>

            {/* PERSUASIVE COPY */}
            <div className="space-y-3 text-brand-text/85 text-xs md:text-sm leading-relaxed" data-id="element-143">
              <p className="text-white font-medium text-sm md:text-base" data-id="element-144">
                Oye, lo entiendo perfectamente...
              </p>
              <p data-id="element-145">
                El precio de la primera oferta no encajaba con tu presupuesto en
                este momento.
              </p>
              <p data-id="element-146">
                Y está <strong className="text-white" data-id="element-147">BIEN</strong>. No todos
                estamos en el mismo lugar financiero.
              </p>
              <p data-id="element-148">Pero déjame hacerte una pregunta:</p>
              <p className="text-white font-bold text-sm md:text-base" data-id="element-149">
                ¿Vas a irte HOY sin NADA... cuando estás a $19.00 de comenzar a
                proteger tu patrimonio?
              </p>

              <Divider data-id="element-150" />

              {/* BUENA NOTICIA */}
              <p className="text-white font-bold text-sm md:text-base" data-id="element-151">
                🎯 AQUÍ ESTÁ LA BUENA NOTICIA:
              </p>
              <p data-id="element-152">
                Tengo algo <strong className="text-white" data-id="element-153">ESPECIAL</strong> para
                personas como tú que:
              </p>
              <div className="space-y-1.5 pl-1" data-id="element-154">
                <div className="flex items-start gap-1.5" data-id="element-155">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-green shrink-0 mt-px" data-id="element-156" />
                  <span data-id="element-157">Ven el valor pero necesitan empezar más pequeño</span>
                </div>
                <div className="flex items-start gap-1.5" data-id="element-158">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-green shrink-0 mt-px" data-id="element-159" />
                  <span data-id="element-160">Quieren resultados sin comprometer su liquidez</span>
                </div>
                <div className="flex items-start gap-1.5" data-id="element-161">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-green shrink-0 mt-px" data-id="element-162" />
                  <span data-id="element-163">Prefieren probar primero antes de ir grande</span>
                </div>
              </div>

              <p className="text-white font-bold text-base md:text-lg mt-2" data-id="element-164">
                "El Índice de Activos Tangibles"
              </p>
              <p data-id="element-165">
                Antes:{' '}
                <span className="line-through text-brand-muted" data-id="element-166">$47.00</span>
              </p>
              <p className="text-brand-gold font-bold text-lg md:text-xl" data-id="element-167">
                HOY SOLAMENTE: $19.00
              </p>

              <div className="space-y-1 pl-1" data-id="element-168">
                <p data-id="element-169">💰 Es MENOS de lo que gastas en una cena fuera</p>
                <p data-id="element-170">💰 Es UN SOLO pago (no suscripción)</p>
                <p data-id="element-171">💰 Es 67% más barato que el precio normal</p>
              </div>
              <p data-id="element-172">
                Y lo mejor:{' '}
                <strong className="text-white" data-id="element-173">FUNCIONA igual de bien.</strong>
              </p>

              <Divider data-id="element-174" />

              {/* PROBLEMA */}
              <p className="text-white font-bold text-sm md:text-base" data-id="element-175">
                ⚠️ PERO HAY UN PROBLEMA...
              </p>
              <p data-id="element-176">Esta oferta solo existe porque dijiste "no" a la primera.</p>
              <p data-id="element-177">
                Si cierras esta página,{' '}
                <strong className="text-white" data-id="element-178">desaparece para siempre.</strong>
              </p>
              <p data-id="element-179">No habrá segunda oportunidad.</p>
              <p className="text-white font-semibold" data-id="element-180">
                Tienes 5 minutos para decidir.
              </p>

              <Divider data-id="element-181" />

              {/* PIENSA EN ESTO */}
              <p className="text-white font-bold text-sm md:text-base" data-id="element-182">
                🧠 PIENSA EN ESTO:
              </p>
              <p data-id="element-183">Hace 2 minutos estabas interesado.</p>
              <p data-id="element-184">El ÚNICO problema fue el precio.</p>
              <p data-id="element-185">
                Ahora ese problema está{' '}
                <strong className="text-white" data-id="element-186">RESUELTO.</strong>
              </p>
              <p className="text-white font-semibold" data-id="element-187">¿Qué te detiene ahora?</p>

              <Divider data-id="element-188" />

              {/* LO QUE OBTIENES */}
              <p className="text-white font-bold text-sm md:text-base" data-id="element-189">
                ✅ LO QUE OBTIENES POR SOLO $19.00:
              </p>
              <div className="space-y-1 pl-1" data-id="element-190">
                <p data-id="element-191">→ Sistema completo de evaluación de activos tangibles</p>
                <p data-id="element-192">→ Checklist de liquidez, riesgo y potencial de reventa</p>
                <p data-id="element-193">
                  → Método para comparar activos sin dejarte llevar por la
                  emoción
                </p>
                <p data-id="element-194">
                  → Mapa de los errores más costosos al invertir (y cómo
                  evitarlos)
                </p>
                <p data-id="element-195">→ Acceso inmediato (en 2 minutos)</p>
                <p data-id="element-196">→ Garantía de devolución de 7 días</p>
              </div>

              <Divider data-id="element-197" />

              {/* REALIDAD SIN FILTROS */}
              <p className="text-white font-bold text-sm md:text-base" data-id="element-198">
                🔴 LA REALIDAD SIN FILTROS:
              </p>
              <p data-id="element-199">Mira, puedo ofrecerte esto porque:</p>
              <div className="space-y-1 pl-1" data-id="element-200">
                <p data-id="element-201">1. Ya cubrí costos con la primera oferta</p>
                <p data-id="element-202">2. Prefiero que te vayas con ALGO que con nada</p>
                <p data-id="element-203">3. Sé que si funciona para ti, volverás</p>
              </div>
              <p data-id="element-204">
                Pero esta oferta me{' '}
                <strong className="text-white" data-id="element-205">CUESTA</strong> dinero mantenerla
                abierta.
              </p>
              <p data-id="element-206">Por eso solo tienes 5 minutos.</p>
              <p data-id="element-207">
                Después de eso, se cierra automáticamente y vuelves a ver el
                precio completo de $47.
              </p>

              <Divider data-id="element-208" />

              {/* IMAGINA ESTO */}
              <p className="text-white font-bold text-sm md:text-base" data-id="element-209">
                💭 IMAGINA ESTO:
              </p>
              <p data-id="element-210">
                En los próximos días podrías saber exactamente en qué activos
                tangibles mover tu dinero...
              </p>
              <p data-id="element-211">
                O en los próximos días podrías estar en el mismo lugar donde
                estás ahora, pensando:
              </p>
              <p className="italic text-brand-gold" data-id="element-212">
                "¿Por qué no aproveché esos $19.00?"
              </p>
              <p data-id="element-213">
                La diferencia la haces{' '}
                <strong className="text-white" data-id="element-214">TÚ</strong> en los próximos 4
                minutos.
              </p>

              <Divider data-id="element-215" />

              {/* GARANTÍA TRIPLE */}
              <p className="text-white font-bold text-sm md:text-base" data-id="element-216">
                🔒 GARANTÍA TRIPLE SIN RIESGO:
              </p>
              <div className="space-y-1 pl-1" data-id="element-217">
                <p data-id="element-218">
                  1. Si no ves resultados en 7 días →{' '}
                  <strong className="text-white" data-id="element-219">Devolución completa</strong>
                </p>
                <p data-id="element-220">
                  2. Si no te gusta el producto →{' '}
                  <strong className="text-white" data-id="element-221">Devolución completa</strong>
                </p>
                <p data-id="element-222">
                  3. Si simplemente cambias de opinión →{' '}
                  <strong className="text-white" data-id="element-223">Devolución completa</strong>
                </p>
              </div>
              <p data-id="element-224">
                Literalmente{' '}
                <strong className="text-white" data-id="element-225">NO HAY RIESGO.</strong>
              </p>
              <p data-id="element-226">Solo tienes que decidir si $19.00 vale la pena intentarlo.</p>

              <Divider data-id="element-227" />

              {/* ÚLTIMA ADVERTENCIA */}
              <div className="bg-brand-red/10 border border-brand-red/20 rounded-lg p-3" data-id="element-228">
                <p className="text-white font-bold text-xs md:text-sm mb-2" data-id="element-229">
                  ❌ ÚLTIMA ADVERTENCIA:
                </p>
                <p className="text-brand-text/85" data-id="element-230">Si te vas ahora:</p>
                <div className="space-y-1 mt-1" data-id="element-231">
                  <p className="text-brand-text/85" data-id="element-232">
                    → Pierdes los $33.00 de descuento (para siempre)
                  </p>
                  <p className="text-brand-text/85" data-id="element-233">
                    → Pierdes esta oportunidad única
                  </p>
                  <p className="text-brand-text/85" data-id="element-234">
                    → Vuelves a la casilla de inicio
                  </p>
                </div>
                <p className="text-brand-text/85 mt-1.5" data-id="element-235">
                  Y lo peor: mañana pensarás{' '}
                  <em className="text-brand-gold" data-id="element-236">"debí haberlo tomado"</em>.
                </p>
              </div>

              <Divider data-id="element-237" />

              {/* DECISIÓN SIMPLE */}
              <p className="text-white font-bold text-sm md:text-base" data-id="element-238">
                🎯 DECISIÓN SIMPLE:
              </p>
              <p className="text-white" data-id="element-239">
                ¿$19.00 para comenzar a proteger tu patrimonio con garantía
                total?
              </p>
              <p className="text-brand-muted" data-id="element-240">O</p>
              <p className="text-brand-muted" data-id="element-241">
                ¿$0 y quedarte exactamente donde estás?
              </p>
              <p className="text-white font-bold mt-1" data-id="element-242">
                Tú eliges. Pero elige RÁPIDO.
              </p>
              <p className="text-brand-gold font-semibold" data-id="element-243">
                El reloj no se detiene.
              </p>
            </div>
          </div>

          {/* Order Summary */}
          <div className="border-t border-brand-gold/10 bg-brand-bg/50 px-4 md:px-6 py-2 md:py-3" data-id="element-244">
            <div className="max-w-xs ml-auto space-y-1" data-id="element-245">
              <div className="flex items-center justify-between text-[11px] md:text-sm" data-id="element-246">
                <span className="text-brand-muted" data-id="element-247">Subtotal</span>
                <span className="text-white font-medium" data-id="element-248">$19.00</span>
              </div>
              <div className="flex items-center justify-between text-[11px] md:text-sm" data-id="element-249">
                <span className="text-brand-muted" data-id="element-250">Impuestos</span>
                <span className="text-brand-muted" data-id="element-251">N/A</span>
              </div>
              <div className="border-t border-brand-gold/15 pt-1.5 flex items-center justify-between" data-id="element-252">
                <span className="text-white font-bold text-xs md:text-sm" data-id="element-253">
                  Total
                </span>
                <span className="text-white font-bold text-sm md:text-lg" data-id="element-254">
                  USD $19.00
                </span>
              </div>
            </div>
          </div>

          {/* Hotmart Sales Funnel Widget */}
          <div className="px-4 md:px-6 pb-3 pt-1" data-id="element-255">
            <HotmartSalesFunnel data-id="element-256" />
          </div>

          {/* Guarantee */}
          <p className="text-center text-brand-muted text-xs italic pb-4" data-id="element-257">
            100% Garantizado
          </p>
        </div>
      </div>
    </div>;
}